// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_fo","catalogByServiceItem__title":"c-l_fp"};